import { isBaiduMap, addPvNew } from '../../../../../utils';
import contentText from '../../contentText.vue';
export default {
  props: {
    button_url: {
      type: String,
      default: ''
    },
    push_third_url: {
      type: String,
      default: ''
    },
    push_third_text: {
      type: String,
      default: ''
    },
    push_title: {
      type: String,
      default: ''
    },
    push_content: {
      type: String,
      default: ''
    },
    push_type: {
      type: String,
      default: ''
    },
    source: {
      type: String,
      default: ''
    },
    cover: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    contentText
  },
  data() {
    return {
      isBaiduMap: isBaiduMap(),
      bgColorMap: {
        'voice_package': 'linear-gradient(-87deg, #8E7AFF 5%, #6347FF 100%)',
        'taxi': 'linear-gradient(-87deg, #4DA6FF 5%, #0583FF 100%)',
        'hotel': 'linear-gradient(-87deg, #FF6E61 5%, #FF5C4D 100%)'
      },
      backupBgColor: 'linear-gradient(-87deg, #4DA6FF 5%, #0583FF 100%)',
      changeStyle: false
    };
  },
  computed: {
    conHeight() {
      const winWidth = window.innerWidth;
      const conHeight = 3 * winWidth / 4;
      if (this.push_type === 'warning' && conHeight) {
        return conHeight + 'px';
      }
      return 'auto';
    },
    contentBgColor() {
      if (this.push_type === 'warning') {
        return {};
      }
      const bgColorMap = this.bgColorMap || {};
      const pushType = this.push_type || '';
      const backupBgColor = this.backupBgColor || '';
      const styleObj = {
        backgroundImage: bgColorMap[pushType],
        color: '#fff',
        opacity: 1,
        zIndex: 0
      };
      if (bgColorMap[pushType]) {
        styleObj.backgroundImage = bgColorMap[pushType];
      } else {
        styleObj.backgroundImage = backupBgColor;
      }
      return styleObj;
    },
    defaultImg() {
      return 'https://map-mobile-resource.cdn.bcebos.com/icon/service/search/default/default-feed.png';
    }
  },
  methods: {
    // 跳转到第三方
    goThird(type) {
      const jumpUrl = type === 'title' ? this.push_third_url : this.button_url || '';
      this.$emit('jump-url', jumpUrl);
      if (type === 'btn') {
        addPvNew(['MCEDse.MCEDpoiugc.NewMedia.microDetail.zubofuwu.click'], {
          pushywf: this.push_type,
          source: this.source
        });
      }
    }
  }
};